import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

// Gate for the StayMii E-Ticket admin area (Hub + Scanner).
// Uses the same unified login as StayMii Lite — any authenticated unified user can access (multi-user).
export default function EticketProtectedRoute({ children }) {
  const [state, setState] = useState('checking'); // checking | ok | denied

  useEffect(() => {
    const token = localStorage.getItem('unified_token') || localStorage.getItem('token');
    if (!token) { setState('denied'); return; }
    let cancelled = false;
    axios.get(`${API_URL}/api/auth/unified/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => { if (!cancelled) setState('ok'); })
      .catch(() => { if (!cancelled) setState('denied'); });
    return () => { cancelled = true; };
  }, []);

  if (state === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="eticket-auth-loading">
        <Loader2 className="w-8 h-8 animate-spin text-[#0C2159]" />
      </div>
    );
  }
  if (state === 'denied') {
    return <Navigate to="/auth/login" replace />;
  }
  return children;
}
